import clsx from "clsx"

import { Icon, NavigationLink } from "@atoms"

import styles from "./BottomBarItem.module.scss"
import { BottomBarItemProps } from "./BottomBarItem.types"

export default function BottomBarItem(props: BottomBarItemProps) {
    const { title, path, icon, iconActive, isActive, isDisabled } = props

    return (
        <NavigationLink
            title={title}
            path={path}
            className={clsx(styles.base, {
                [styles.disabled]: isDisabled,
            })}
            activeClassName={styles.active}
            isActive={isActive}
            isDisabled={isDisabled}
        >
            {(isActive) => (
                <div className={styles.innerContainer}>
                    <Icon size={16} isActive={isActive} icon={icon} iconOnActive={iconActive} />
                    <span className={styles.label}>{title}</span>
                </div>
            )}
        </NavigationLink>
    )
}
